<!-- Image tags show and edit component -->
<template>
  <div class="form-group">
    <!-- Tags input -->
    <input v-show="false" type="text" class="form-control" v-model="tagsStr" />

    <!-- Tags list -->
    <div class="tag-list mt-3">
      <span
        v-for="tag in tagsAr"
        :key="tag"
        class="badge badge-secondary border"
      >
        {{ tag }}
        <span>
          <i
            class="bi bi-x-circle"
            title="Delete tag"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            @click="
              confirm = 'remove';
              removeTag = tag;
              actions.remove.text = 'Remove \'' + tag + '\' tag?';
            "
          ></i>
        </span>
      </span>
    </div>

    <!-- Confirm actions -->
    <ActionConfirm
      :action="actions[confirm]"
      @confirm="
        delTag(removeTag);
        confirm = '';
      "
      @cancel="confirm = ''"
    />

    <!-- New tag -->
    <form v-if="!confirm" class="form-group mt-2" v-on:submit.prevent="addTag">
      <div class="input-group">
        <input
          type="text"
          v-model="newTag"
          class="form-control"
          placeholder="Add new tag"
        />
        <button v-show="newTag" class="btn btn-primary" type="submit">
          Add
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ActionConfirm from "./ActionConfirm.vue";

const cmdSetImageTags = "images.tags.set/";

export default {
  name: "ImageTags",

  components: {
    ActionConfirm,
  },

  props: {
    id: String,
    tags: String,
  },

  data() {
    return {
      tagsStrSaved: "",
      tagsStr: "",
      tagsAr: [],
      newTag: "",

      /** confirm action */
      confirm: "",
      removeTag: "",
      actions: {
        remove: {
          name: "remove",
          text: "Remove this tag?",
        },
      },
    };
  },

  mounted() {
    const tags = this.tags;
    this.tagsStrSaved = tags;
    this.tagsStr = tags;
  },

  watch: {
    /**  tagsStr update tagsAr when tagsStr changed */
    tagsStr(v) {
      if (!v) {
        this.tagsAr = [];
        this.updateTags();
        return;
      }
      this.tagsAr = v.split(",");
      this.tagsAr.sort();
      this.updateTags();
    },
  },

  methods: {
    delTag(tag) {
      this.tagsAr = this.tagsAr.filter((t) => t !== tag);
      this.tagsStr = this.tagsAr.join(",");
    },

    addTag() {
      if (!this.newTag) return;
      if (this.tagsAr.indexOf(this.newTag) == -1) {
        this.tagsAr.push(this.newTag);
        this.tagsStr = this.tagsAr.join(",");
      }
      this.newTag = "";
    },

    updateTags() {
      if (this.tagsStrSaved == this.tagsStr) return;

      this.tagsStrSaved = this.tagsStr;
      this.sendCmd(cmdSetImageTags + this.id, this.tagsStr).then(
        // Process success answer
        () => {
          // console.debug("cmdSetImageTags:", data);
        },
        // Process an error
        (err) => console.error("cmdSetImageTags error:", err)
      );
    },
  },
};
</script>

<style scoped>
.badge {
  color: var(--bs-card-color);
  font-size: medium;
  font-weight: normal;
  margin-right: 5px;
  margin-bottom: 5px;
}
.badge i {
  margin-left: 5px;
  cursor: pointer;
}
</style>
